import { useSchoolQuery } from '@/composables/queries/useSchoolQuery';
import { schoolLabels } from '@/constants/general-constants';

export function useSchoolLabels() {
  const { school } = useSchoolQuery();

  const labels = computed(() => {
    const type = (school.value?.school_type || 'secondary').toLowerCase();
    return schoolLabels[type as keyof typeof schoolLabels] || schoolLabels.secondary;
  });

  return {
    labels,
  };
}
